var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 11.7C10.2673 11.7 11.7 10.2673 11.7 8.5C11.7 6.73269 10.2673 5.3 8.5 5.3C6.73269 5.3 5.3 6.73269 5.3 8.5C5.3 10.2673 6.73269 11.7 8.5 11.7Z",
    stroke: "#757575",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 12.1C17.9359 12.1 19.1 10.9359 19.1 9.5C19.1 8.06406 17.9359 6.9 16.5 6.9C15.0641 6.9 13.9 8.06406 13.9 9.5C13.9 10.9359 15.0641 12.1 16.5 12.1Z",
    stroke: "#757575",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.6 19C2.6 16 5.2 14.2 8.5 14.2C11.8 14.2 14.4 16 14.4 19M16 14.6C18.8 14.6 21 16.1 21 18.6",
    stroke: "#757575",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTeam);
export default __webpack_public_path__ + "static/media/nav-team.91f4f225d218949a15f4fb68b0d61a92.svg";
export { ForwardRef as ReactComponent };